import WebSDK from "@yo-star/websdk"

import configJson from "../../SDKConfigSettings.json"

const webSDK = new WebSDK(configJson as any)
let initPromise: Promise<boolean> | null = null

/**
 * 初始化 WebSDK，返回是否初始化成功
 * 多次调用只会初始化一次
 */
export const webSdkReady = () => {
    if (!initPromise) {
        initPromise = webSDK
            .Init({ PID: "KR-ARKNIGHTS" })
            .then((res) => {
                return res.code === 0
            })
            .catch(() => {
                initPromise = null
                return false
            })
    }
    return initPromise
}

/**
 * 调用 WebSDK 登录，返回 LOGIN_UID 和 LOGIN_TOKEN
 * 如果失败返回 null
 */
export const webSdkLogin = async () => {
    const isReady = await webSdkReady()
    if (!isReady) {
        return null
    }

    const res = await webSDK.Login()
    if (res.code === 0) {
        return {
            loginUid: res.data?.LOGIN_UID || "",
            loginToken: res.data?.LOGIN_TOKEN || "",
        }
    }

    return null
}

/**
 * 调用 WebSDK 登出
 */
export const webSdkLogout = async () => {
    await webSDK.Logout()
}
